import { Interest } from '../../../models/interest';
export const GRADES = ['6th', '7th', '8th', '9th', '10th', '11th', '12th'];

export const CAREERS = [
  { id: 1, icon: '💻', label: 'Technology' },
  { id: 2, icon: '⚕️', label: 'Medicine' },
  { id: 3, icon: '⚖️', label: 'Law' },
  { id: 4, icon: '🏛️', label: 'Architecture' },
  { id: 5, icon: '📚', label: 'Education' },
  { id: 6, icon: '⚙️', label: 'Engineering' },
  { id: 7, icon: '🎨', label: 'Arts & Design' },
  { id: 8, icon: '💼', label: 'Business' },
  { id: 9, icon: '🔬', label: 'Science' },
];

export const INTERESTS: Interest[] = [
  { id: 1, name: 'Coding' },
  { id: 2, name: 'Music' },
  { id: 3, name: 'Sports' },
  { id: 4, name: 'Art & Design' },
  { id: 5, name: 'Science' },
  { id: 6, name: 'Math' },
  { id: 7, name: 'Writing' },
  { id: 8, name: 'Community service' },
  { id: 9, name: 'Leadership' },
  { id: 10, name: 'Entrepreneurship' },
  { id: 11, name: 'Health & fitness' },
  { id: 12, name: 'Gaming' },
];
